import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'a-animated-separator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './animated-separator.component.html',
  styleUrls: ['./animated-separator.component.scss'],
})
export class AnimatedSeparatorComponent {
  // if true, it is a bottom separator. Else top.
  @Input() offset: 'top' | 'bottom' = 'bottom';

  // Animation speed.
  @Input() speed = 1;

  get animationDurationtyle() {
    // Default is 15 seconds for one loop
    const seconds = 15 / this.speed;
    return `animation-duration: ${seconds}s;`;
  }
}
